<template>
  <header class="modal-header bg-light">
    <h5 class="modal-title">{{this.title}}</h5>
    <button @click="$emit('close')" type="button" aria-label="Close" aria-hidden="true" class="close">×</button>
  </header>
</template>

<script>
export default {
  name: 'modal-title',
  props: {
    title: String,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ModalTitle.vue